export const translationsDashboard_sv_part2 = {
  assign: "Tilldela",
  assignedTo: "Tilldelad till",
  assignedToMe: "Tilldelad mig",
  assignedToYou: "Tilldelad dig",
  unassign: "Ta bort tilldelning",
  unassigned: "Ej tilldelad",
  unknownUser: "Okänd användare",
  resolutionRate: "Lösningsgrad",
  handoverRequiredRate: "Kundtjänst krävdes",
  fallbackRate: "Fallback-andel",
  userRequestedCustomerServiceRate: "Användare begärde kundtjänst",
  resolutionCategoryContained: "Löst utan överlämning",
  resolutionCategoryHandoverRequired: "Kundtjänst krävdes",
  resolutionCategoryFallback: "Fallback",
  resolutionCategoryCustomerRequestedService: "Användare begärde kundtjänst",
  resolutionCategoryFilterApplied: "Visar konversationer med",
  commentsLabel: "Kommentarer",
  noComments: "Inga kommentarer ännu",
  usernamePlaceholder: "Ditt namn",
  addCommentPlaceholder: "Lägg till en kommentar...",
  addComment: "Lägg till kommentar",
  adding: "Lägger till...",
  editComment: "Redigera kommentar",
  deleteComment: "Radera kommentar",
  confirmDeleteComment: "Är du säker på att du vill radera den här kommentaren?",
  save: "Spara",
  cancel: "Avbryt",
  commentPlaceholder: "Kommentar",
  unreadComments: "Olästa kommentarer",
  uploadingImage: "Laddar upp bild...",
  imageUploadFailed: "Kunde inte ladda upp bild.",
  reportImageAlt: "Rapportbild",
  removeImage: "Ta bort bild",
  uploadImage: "Ladda upp bild",
  mentionedConversationsFilter: "Omnämnanden av mig",
  mentionFilterEmpty: "Inga olösta rapporter där du omnämnts matchar dina filter.",
  mentionAllTeam: "@all",
  mentionAllTeamHint: "Alla i organisationen",
  mentionSomeone: "Omnämn någon",
  insertEmoji: "Infoga emoji",
  mentionReportParticipant: "Deltagare i den här rapporten",
  adminUnreadCommentsMarker: "Admins: olästa kommentarer finns i det här filtret",
  markAllUnreadCommentsRead: "Markera alla som lästa",
  markingUnreadCommentsRead: "Rensar...",
  unreadMentionBadge: "Oläst omnämnande",
  mentionFeatureAnnouncementTitle: "Nytt: Tilldela och omnämn teammedlemmar",
  mentionFeatureAnnouncementP1:
    "I rapporter kan du tilldela konversationen till en teammedlem eller skriva @ i kommentarsfältet för att omnämna specifika personer.",
  mentionFeatureAnnouncementP2:
    "Använd @all för hela organisationen. Olästa olösta rapporter du följer visas i filtret och du kan rensa gamla olästa kommentarer med en åtgärd.",
  mentionFeatureAnnouncementOk: "Uppfattat",
  mentionFeatureAnnouncementDontShowAgain: "Visa inte det här meddelandet igen",
  // Product button translation
  // Product button translation
  viewProduct: "VISA PRODUKT",
  companyInfo: "Företagsinformation",
  livechat: "Livechat",
  // Context chunks translations
  // Context chunks translations
  showContext: "Visa kontextkällor",
  hideContext: "Dölj kontextkällor",
  loadingContextChunks: "Laddar kontext...",
  noContextChunks: "Ingen kontextinformation tillgänglig för det här meddelandet.",
  contextUsed: "Kontext som användes för att generera det här svaret:",
  source: "Källa",
  relevance: "relevans",
  contextChunkOriginUploaded: "Uppladdad",
  contextChunkOriginScrapedPage: "Skrapad sida",
  page: "Sida",
  conversationUnavailable:
    "Den här konversationen har raderats eller är inte längre tillgänglig för dig.",
  // AI debug data translations (admin only)
  // AI debug data translations (admin only)
  showAiDebug: "Visa AI-felsökningsinfo",
  hideAiDebug: "Dölj AI-felsökningsinfo",
  loadingAiDebug: "Laddar AI-felsökningsinfo...",
  noAiDebug: "Ingen AI-felsökningsinformation tillgänglig för det här meddelandet.",
  aiDebugTitle: "AI-felsökningsinformation",
  urlValidatorLabel: "URL-validerings korrigeringar",
  vectorStoreLabel: "Vektorlager",
  vectorStorePgvector: "pgvector",
  searchMethodLabel: "Sökmetod",
  searchMethodKeywordFallback: "Nyckelordssökning · automatisk fallback",
  searchMethodKeywordFallbackDescription:
    "Inbäddning av frågan misslyckades eller fick timeout. Det här svaret använde pgvector nyckelordssökning istället för semantisk sökning.",
  searchMethodKeywordOnly: "Nyckelordssökning · konfigurerad i flöde",
  searchMethodKeyword: "Nyckelordssökning",
  searchMethodSemantic: "Semantisk sökning",
  llmProviderLabel: "LLM-leverantör",
  llmProviderVertex: "Google Vertex",
  llmProviderBedrock: "AWS Bedrock",
  llmProviderOpenai: "OpenAI",
  llmFallbackReasonLabel: "LLM-fallback-orsak",
  fallbackReasonLabel: "Hämtnings-fallback-orsak",
  rephraseLabel: "Omformulerad fråga",
  fordelingsflowLabel: "Fördelningsflöde resultat",
  metadataFiltersLabel: "Metadatafilter",
  hardcodedMetadataFilterLabel: "Hårdkodat metadatafilter",
  noRephrase: "Ingen omformulering (första meddelandet eller hälsning)",
  noFordelingsflow: "Inget fördelningsflöde utfört",
  agentExecutionLogLabel: "Integrationshantering (före streaming)",
  noMetadataFilters: "Inga metadatafilter tillämpade",
  noHardcodedMetadataFilter: "Inget hårdkodat metadatafilter",
  metadataFilterSuccessBanner: "Filter returnerade resultat",
  hardcodedFilterFellBackLabel: "Hårdkodat filter föll tillbaka till ofiltrerad sökning:",
  hardcodedFilterFellBackBanner:
    "Hårdkodat filter returnerade inga resultat – föll tillbaka till ofiltrerad sökning",
  hardcodedFilterSuccessBanner: "Hårdkodat filter returnerade resultat",
  topicFilterApplied: "Filtrerat efter ämne",
  purchaseFilterApplied: "Visar konversationer med köp",
  leadsFilterApplied: "Visar leads",
  timePeriod: "Tidsperiod",
  timePeriodAll: "Alla",
  timePeriodToday: "Idag",
  timePeriodYesterday: "Igår",
  timePeriodThisWeek: "Den här veckan",
  timePeriodLast7Days: "Senaste 7 dagarna",
  timePeriodThisMonth: "Den här månaden",
  timePeriodLast30Days: "Senaste 30 dagarna",
  timePeriodFilterApplied: "Filtrerat efter tidsperiod",
  filterApplied: "Filter tillämpat",
  uploadData: "Ladda upp data",
  editSubject: "Redigera ämne",
  selectSubject: "Välj ämne...",
  open: "Öppen",
  closed: "Stängd",
  leads: "Kontaktformulär",
  testConversation: "Testkonversation",
  sessionContext: "Sessionskontext",
  conversationProductClicked: "Produkt klickad",
  conversationLinkClicked: "Länk klickad",
  conversationNoRecordedClicks: "Inga registrerade klick",
  draftUsageWordsRetained: "{{matched}} av {{draft}} utkastord i ett svar på {{response}} ord",
  emailSenderAgent: "Kundtjänst",
  emailSenderAgentVia: "Skickat från {{provider}}",
  emailSenderDraft: "AI-utkast",
  emailSenderDraftDescription: "Föreslagen svar, inte skickat till kunden",
  emailSenderNote: "Intern notering",
  emailSenderNoteDescription: "Inte synlig för kunden",
  emailSenderSent: "Skickat av automatisering",
  emailSenderSentDescription: "AI-svar skickat automatiskt till kunden",
  emailDraftUsageReply: "{{percentage}}% matchning med AI-utkastet",
  verifiedMetadataLabel: "Verifierade kunddata",
  sessionMetadataLabel: "Sessionsmetadata",
  sessionMetadataUnverified: "Ej verifierad",
  sessionMetadataHint:
    "Tillhandahållen av besökarens webbläsare. Dessa värden är inte verifierade.",
  sessionMetadataConversationEmail: "E-post angiven före chatten",
  verifiedMetadataHint: "Signerad av kundens webbplats och verifierad av oss, så den kan litas på.",
  fieldTypeTextarea: "Textområde",
  deviceLabel: "Enhet",
  deviceDesktop: "Dator",
  deviceTablet: "Surfplatta",
  devicePhone: "Mobil",
  deviceNotRecorded: "Inte registrerad",
};
